export class Checkingcloture {
   public histoactivitedatecreation: string;
   public caisseid : string ;
   public chiffreaffaire : any ;
}